<script>
  // your script goes here
</script>

<div class="test-env-banner">Test environment</div>

<style>
  .test-env-banner {
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 16px;
    font-weight: bold;
    font-size: 10px;
    text-transform: uppercase;
    width: 100%;
    height: 20px;
    background-color: #fdf35c;
    color: rgba(80, 75, 2, 0.5);
  }
</style>
